import {
  Button,
  IconButton,
  Grid,
  Icon,
  Typography,
  Link,
  Backdrop,
  Chip,
} from "@mui/material";
import React, { useState, createRef, useEffect } from "react";
import { useSnackbar } from 'notistack';
import { MatchBreakdown } from "./MatchBreakdown";
import { useDispatch } from "react-redux";
import { getIndeedDescription, getReedDescription } from "../../../actions/job_actions";
import CloseIcon from "@mui/icons-material/Close";

const JobListView = ({ onDismiss, job, candidate, onInviteToVacancy }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [showSkillMatch, setShowSkillMatch] = useState(false);
  const [loading, setLoading] = useState(false);
  const ref = createRef(null);
  const [descriptionFull, setDescriptionFull] = useState(false);
  const [previousJobId, setPreviousJob] = useState(false);
  const [openSkillGapJob] = useState(true);

  const isVacancy = job.provider === "skillzMiner"
  let { jobDescription, provider, jobId } = job;

  if (previousJobId !== job.jobId) {
    setPreviousJob(job.jobId);
    setDescriptionFull(false);
  }

  const [right, setRight] = useState("-1000px");

  useEffect(() => {
    setTimeout(() => {
      setRight("0px");
    }, 100); // A small delay to ensure the component is mounted for the transition
  }, []);

  return (
    <>
    {showSkillMatch ? (
      <Backdrop
        open={showSkillMatch}
        sx={{ zIndex: 100000 }}
      >
        <MatchBreakdown
          defaultType={"skills"}
          onClose={() => {
              setShowSkillMatch(false)
            }}
          job={job}
          candidate={candidate}
        />
      </Backdrop>
    ) : null}

    <Backdrop open={openSkillGapJob} sx={{ zIndex: 10001 }}>
      <div style={{
        right: right,
        width: { xs: "100vw", sm: 520 },
        height: "100%",
        position: "absolute",
        transition: "all 0.5s"
      }}>
        <div style={{ backgroundColor: "#ffffff", height: '100%', position: 'relative' }}>
          <IconButton sx={{
            right: 10,
            position: "absolute",
            zIndex: 10
          }} className="close-button" onClick={() => {
            setRight("-1000px");
            setTimeout(() => {
              onDismiss();
            }, 250);
          }}>
            <CloseIcon sx={{ color: "black" }} />
          </IconButton>
          <Grid container direction="column" sx={{
            padding: "1.5em", width: "100%", height: "calc(100% - 50px)", overflowY: "auto", background: "white"
          }}>
      <Grid item size>
        <Grid container justifyContent="space-between" alignItems="flex-start">
          <Grid item sm={12} md={12}>
            <Typography variant={"h4"} style={{ marginTop: 10 }}> {job.jobTitle}</Typography>
            <Typography variant={"h5"} style={{ marginTop: 10 }}>{job.employerName}</Typography>
            <Grid
              container
              alignContent="flex-start"
              spacing={1}
              direction="column"
              alignItems="baseline"
            >
              <Grid item>
                <Grid container alignItems="center" style={{ marginTop: 15 }}>
                  <Grid item>
                    <Icon color="primary">location_on</Icon>
                  </Grid>
                  <Grid item style={{ paddingLeft: "0.3em" }}>
                    {job.original_location}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item size>
                <Grid container alignItems="center" style={{ marginTop: 5 }}>
                  <Grid item style={{ paddingLeft: "0.3em" }}>
                    <Icon
                      color="primary"
                      className="fas fa-money-bill"
                      style={{ textAlign: "center" }}
                    />
                  </Grid>
                  <Grid item style={{ paddingLeft: "0.3em" }}>
                    {job.salary_type ? (
                      job.salary_type === "hourly" ? job.annual_salary_max + " per hour" :
                        job.salary_type === "daily" ? job.annual_salary_max + " per day" :
                          job.annual_salary_max + " per annum"
                    ) : "Salary Unknown"}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item size>
                <Grid container alignItems="center" style={{ marginTop: 5 }}>
                  <Grid item>
                    <Icon color="primary">timer</Icon>
                  </Grid>
                  <Grid item style={{ paddingLeft: "0.3em" }}>
                    {job.job_contract
                      .split("_")
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(" ")}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item size={{xs:12}} sm={12}>
            <div
              style={{}}
              dangerouslySetInnerHTML={{ __html: descriptionFull ? descriptionFull : jobDescription === "no description" ? "Follow the Apply link to see job description.  " : jobDescription }}
            />
          </Grid>
          {provider && !provider.includes("jooble") && (
            <Grid item size={{xs:12}} sm={12} style={{ display: "flex", flexDirection: "row-reverse", paddingBlock: 10 }}>
              <Button
                disabled={loading || descriptionFull}
                color="primary"
                size="small"
                onClick={async (e) => {
                  setLoading(true)
                  if (provider && provider.includes("indeed")) {
                    setDescriptionFull(await dispatch(getIndeedDescription(jobId)));
                  }
                  else if (provider && (provider.includes("reed") || provider.includes("Reed"))) {
                    setDescriptionFull(await dispatch(getReedDescription(jobId)));
                  }
                  else {
                    setDescriptionFull(jobDescription);
                  }
                  setLoading(false)
                }}
              >
                Show more
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
          <Grid container sx={{ paddingRight: '10px', bottom: 0, paddingTop: '5px', background: "#ffffff", height: 50, position: "absolute", marginTop: '15px' }}>
      {(isVacancy && (
        <Grid item xs style={{ textAlign: "left" }}>
              <Chip label="Promoted Vacancy" sx={{ fontSize: 14, backgroundColor: "#999", color: "white", paddingBottom: '2px' }} />
        </Grid>
      ))}
      <Grid item xs style={{ textAlign: "right" }}>
        <Button color="primary" style={{ marginRight: 10 }} variant="contained" onClick={() => {
          setShowSkillMatch(true);
        }}>
          View Skill Gap
        </Button>
        <Button color="primary" style={{ marginRight: 10 }} variant="contained" onClick={() => {
          onInviteToVacancy(candidate.userID, job)
          enqueueSnackbar('The candidate has been notified of the selected job listing', { variant: 'success', autoHideDuration: 2000 })
        }}>
          Invite candidate to apply
        </Button>
        <Link ref={ref} href={job.job_url} target="_blank"
          onMouseDown={() => {
            if (job.provider === "indeed" && job.onmousedown) {
              let arr = job.onmousedown.split(",");
              let id = arr[1];
              window.indeed_clk(ref.current, id.replace(")", "").replace(";", ""));
            }
          }}>
          <Button color="primary" variant="contained">
            Apply
          </Button>
        </Link>
      </Grid>
    </Grid>
    </div>
    </div>
    </Backdrop>
    </>
  );
};

export default JobListView;